
import { useQuery } from "@tanstack/react-query";
import { fetchPlanData } from "./utils/fetchPlanData";
import { optimizedFetchPlanRoutines } from "./utils/optimizedFetchPlanRoutines";

export const useOptimizedWorkoutPlan = (planId: string | undefined) => {
  return useQuery({
    queryKey: ["workout-plan-optimized", planId],
    queryFn: async () => {
      if (!planId) throw new Error("No plan ID provided");
      
      try {
        // Fetch plan data and routines in parallel
        const [plan, routinesWithExercises] = await Promise.all([
          fetchPlanData(planId),
          optimizedFetchPlanRoutines(planId)
        ]);

        console.log("Optimized plan fetch complete:", {
          planName: plan.name,
          routineCount: routinesWithExercises.length
        });

        return {
          ...plan,
          routines: routinesWithExercises
        };
      } catch (error) {
        console.error("Error in useOptimizedWorkoutPlan:", error);
        throw error;
      }
    },
    enabled: !!planId,
    staleTime: 60000,
    gcTime: 300000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 30000),
  });
};
